// @generated by protoc-gen-es v2.10.1 with parameter "target=ts,json_types=true"
// @generated from file onboarding/v1/builder.proto (package onboarding.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import type { FieldMask, FieldMaskJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { StepData, StepDataJson, StepType, StepTypeJson, WorkflowType, WorkflowTypeJson } from "./steps_pb";
import { file_onboarding_v1_steps } from "./steps_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file onboarding/v1/builder.proto.
 */
export const file_onboarding_v1_builder: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_pagination, file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_onboarding_v1_steps],
	);

/**
 * MoveStepTemplateRequest captures the details needed to move a step template within a workflow template.
 *
 * @generated from message onboarding.v1.MoveStepTemplateRequest
 */
export type MoveStepTemplateRequest = Message<"onboarding.v1.MoveStepTemplateRequest"> & {
	/**
	 * workflow_template_id is the unique identifier for the workflow template.
	 *
	 * @generated from field: string workflow_template_id = 1;
	 */
	workflowTemplateId: string;

	/**
	 * step_template_id is the unique identifier for the step template.
	 *
	 * @generated from field: string step_template_id = 2;
	 */
	stepTemplateId: string;

	/**
	 * position defines the position of the step template within the workflow template.
	 *
	 * @generated from field: onboarding.v1.StepTemplatePosition new_position = 3;
	 */
	newPosition?: StepTemplatePosition;
};

/**
 * MoveStepTemplateRequest captures the details needed to move a step template within a workflow template.
 *
 * @generated from message onboarding.v1.MoveStepTemplateRequest
 */
export type MoveStepTemplateRequestJson = {
	/**
	 * workflow_template_id is the unique identifier for the workflow template.
	 *
	 * @generated from field: string workflow_template_id = 1;
	 */
	workflowTemplateId?: string;

	/**
	 * step_template_id is the unique identifier for the step template.
	 *
	 * @generated from field: string step_template_id = 2;
	 */
	stepTemplateId?: string;

	/**
	 * position defines the position of the step template within the workflow template.
	 *
	 * @generated from field: onboarding.v1.StepTemplatePosition new_position = 3;
	 */
	newPosition?: StepTemplatePositionJson;
};

/**
 * Describes the message onboarding.v1.MoveStepTemplateRequest.
 * Use `create(MoveStepTemplateRequestSchema)` to create a new message.
 */
export const MoveStepTemplateRequestSchema: GenMessage<MoveStepTemplateRequest, { jsonType: MoveStepTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 0);

/**
 * MoveStepTemplateResponse returns the moved step template.
 *
 * @generated from message onboarding.v1.MoveStepTemplateResponse
 */
export type MoveStepTemplateResponse = Message<"onboarding.v1.MoveStepTemplateResponse"> & {
	/**
	 * step_template is the moved step template.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step_template = 1;
	 */
	stepTemplate?: StepTemplate;
};

/**
 * MoveStepTemplateResponse returns the moved step template.
 *
 * @generated from message onboarding.v1.MoveStepTemplateResponse
 */
export type MoveStepTemplateResponseJson = {
	/**
	 * step_template is the moved step template.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step_template = 1;
	 */
	stepTemplate?: StepTemplateJson;
};

/**
 * Describes the message onboarding.v1.MoveStepTemplateResponse.
 * Use `create(MoveStepTemplateResponseSchema)` to create a new message.
 */
export const MoveStepTemplateResponseSchema: GenMessage<MoveStepTemplateResponse, { jsonType: MoveStepTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 1);

/**
 * CreateWorkflowTemplateRequest captures the details needed to create a workflow template.
 *
 * @generated from message onboarding.v1.CreateWorkflowTemplateRequest
 */
export type CreateWorkflowTemplateRequest = Message<"onboarding.v1.CreateWorkflowTemplateRequest"> & {
	/**
	 * key is the unique name for the template.
	 *
	 * @generated from field: string key = 1;
	 */
	key: string;

	/**
	 * display_name is the human-readable name for the template.
	 *
	 * @generated from field: string display_name = 2;
	 */
	displayName: string;

	/**
	 * description provides optional detail about the workflow template.
	 *
	 * @generated from field: string description = 3;
	 */
	description: string;

	/**
	 * is_active indicates whether new runs can be created from this template.
	 *
	 * @generated from field: bool is_active = 4;
	 */
	isActive: boolean;

	/**
	 * steps optionally initializes the workflow with step templates.
	 *
	 * @generated from field: repeated onboarding.v1.CreateStepTemplateRequest steps = 5;
	 */
	steps: CreateStepTemplateRequest[];

	/**
	 * type defines the type of workflow template.
	 *
	 * @generated from field: onboarding.v1.WorkflowType type = 6;
	 */
	type: WorkflowType;
};

/**
 * CreateWorkflowTemplateRequest captures the details needed to create a workflow template.
 *
 * @generated from message onboarding.v1.CreateWorkflowTemplateRequest
 */
export type CreateWorkflowTemplateRequestJson = {
	/**
	 * key is the unique name for the template.
	 *
	 * @generated from field: string key = 1;
	 */
	key?: string;

	/**
	 * display_name is the human-readable name for the template.
	 *
	 * @generated from field: string display_name = 2;
	 */
	displayName?: string;

	/**
	 * description provides optional detail about the workflow template.
	 *
	 * @generated from field: string description = 3;
	 */
	description?: string;

	/**
	 * is_active indicates whether new runs can be created from this template.
	 *
	 * @generated from field: bool is_active = 4;
	 */
	isActive?: boolean;

	/**
	 * steps optionally initializes the workflow with step templates.
	 *
	 * @generated from field: repeated onboarding.v1.CreateStepTemplateRequest steps = 5;
	 */
	steps?: CreateStepTemplateRequestJson[];

	/**
	 * type defines the type of workflow template.
	 *
	 * @generated from field: onboarding.v1.WorkflowType type = 6;
	 */
	type?: WorkflowTypeJson;
};

/**
 * Describes the message onboarding.v1.CreateWorkflowTemplateRequest.
 * Use `create(CreateWorkflowTemplateRequestSchema)` to create a new message.
 */
export const CreateWorkflowTemplateRequestSchema: GenMessage<CreateWorkflowTemplateRequest, { jsonType: CreateWorkflowTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 2);

/**
 * CreateWorkflowTemplateResponse returns the created workflow template.
 *
 * @generated from message onboarding.v1.CreateWorkflowTemplateResponse
 */
export type CreateWorkflowTemplateResponse = Message<"onboarding.v1.CreateWorkflowTemplateResponse"> & {
	/**
	 * template is the persisted workflow template with any created steps.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate template = 1;
	 */
	template?: WorkflowTemplate;
};

/**
 * CreateWorkflowTemplateResponse returns the created workflow template.
 *
 * @generated from message onboarding.v1.CreateWorkflowTemplateResponse
 */
export type CreateWorkflowTemplateResponseJson = {
	/**
	 * template is the persisted workflow template with any created steps.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate template = 1;
	 */
	template?: WorkflowTemplateJson;
};

/**
 * Describes the message onboarding.v1.CreateWorkflowTemplateResponse.
 * Use `create(CreateWorkflowTemplateResponseSchema)` to create a new message.
 */
export const CreateWorkflowTemplateResponseSchema: GenMessage<CreateWorkflowTemplateResponse, { jsonType: CreateWorkflowTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 3);

/**
 * UpdateWorkflowTemplateRequest mutates an existing workflow template using the provided object.
 *
 * @generated from message onboarding.v1.UpdateWorkflowTemplateRequest
 */
export type UpdateWorkflowTemplateRequest = Message<"onboarding.v1.UpdateWorkflowTemplateRequest"> & {
	/**
	 * template carries the desired state; the id field must be populated.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate template = 1;
	 */
	template?: WorkflowTemplate;

	/**
	 * update_mask limits which fields from template are applied.
	 *
	 * @generated from field: google.protobuf.FieldMask update_mask = 2;
	 */
	updateMask?: FieldMask;
};

/**
 * UpdateWorkflowTemplateRequest mutates an existing workflow template using the provided object.
 *
 * @generated from message onboarding.v1.UpdateWorkflowTemplateRequest
 */
export type UpdateWorkflowTemplateRequestJson = {
	/**
	 * template carries the desired state; the id field must be populated.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate template = 1;
	 */
	template?: WorkflowTemplateJson;

	/**
	 * update_mask limits which fields from template are applied.
	 *
	 * @generated from field: google.protobuf.FieldMask update_mask = 2;
	 */
	updateMask?: FieldMaskJson;
};

/**
 * Describes the message onboarding.v1.UpdateWorkflowTemplateRequest.
 * Use `create(UpdateWorkflowTemplateRequestSchema)` to create a new message.
 */
export const UpdateWorkflowTemplateRequestSchema: GenMessage<UpdateWorkflowTemplateRequest, { jsonType: UpdateWorkflowTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 4);

/**
 * UpdateWorkflowTemplateResponse returns the updated workflow template.
 *
 * @generated from message onboarding.v1.UpdateWorkflowTemplateResponse
 */
export type UpdateWorkflowTemplateResponse = Message<"onboarding.v1.UpdateWorkflowTemplateResponse"> & {
	/**
	 * template is the workflow template after applying the update.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate template = 1;
	 */
	template?: WorkflowTemplate;
};

/**
 * UpdateWorkflowTemplateResponse returns the updated workflow template.
 *
 * @generated from message onboarding.v1.UpdateWorkflowTemplateResponse
 */
export type UpdateWorkflowTemplateResponseJson = {
	/**
	 * template is the workflow template after applying the update.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate template = 1;
	 */
	template?: WorkflowTemplateJson;
};

/**
 * Describes the message onboarding.v1.UpdateWorkflowTemplateResponse.
 * Use `create(UpdateWorkflowTemplateResponseSchema)` to create a new message.
 */
export const UpdateWorkflowTemplateResponseSchema: GenMessage<UpdateWorkflowTemplateResponse, { jsonType: UpdateWorkflowTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 5);

/**
 * GetWorkflowTemplateRequest fetches a workflow template using a selector.
 *
 * @generated from message onboarding.v1.GetWorkflowTemplateRequest
 */
export type GetWorkflowTemplateRequest = Message<"onboarding.v1.GetWorkflowTemplateRequest"> & {
	/**
	 * id identifies the workflow template to retrieve.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * include_steps controls whether to return the associated step templates.
	 *
	 * @generated from field: bool include_steps = 2;
	 */
	includeSteps: boolean;
};

/**
 * GetWorkflowTemplateRequest fetches a workflow template using a selector.
 *
 * @generated from message onboarding.v1.GetWorkflowTemplateRequest
 */
export type GetWorkflowTemplateRequestJson = {
	/**
	 * id identifies the workflow template to retrieve.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * include_steps controls whether to return the associated step templates.
	 *
	 * @generated from field: bool include_steps = 2;
	 */
	includeSteps?: boolean;
};

/**
 * Describes the message onboarding.v1.GetWorkflowTemplateRequest.
 * Use `create(GetWorkflowTemplateRequestSchema)` to create a new message.
 */
export const GetWorkflowTemplateRequestSchema: GenMessage<GetWorkflowTemplateRequest, { jsonType: GetWorkflowTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 6);

/**
 * GetWorkflowTemplateResponse contains the requested workflow template.
 *
 * @generated from message onboarding.v1.GetWorkflowTemplateResponse
 */
export type GetWorkflowTemplateResponse = Message<"onboarding.v1.GetWorkflowTemplateResponse"> & {
	/**
	 * template is the requested workflow template.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate template = 1;
	 */
	template?: WorkflowTemplate;
};

/**
 * GetWorkflowTemplateResponse contains the requested workflow template.
 *
 * @generated from message onboarding.v1.GetWorkflowTemplateResponse
 */
export type GetWorkflowTemplateResponseJson = {
	/**
	 * template is the requested workflow template.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate template = 1;
	 */
	template?: WorkflowTemplateJson;
};

/**
 * Describes the message onboarding.v1.GetWorkflowTemplateResponse.
 * Use `create(GetWorkflowTemplateResponseSchema)` to create a new message.
 */
export const GetWorkflowTemplateResponseSchema: GenMessage<GetWorkflowTemplateResponse, { jsonType: GetWorkflowTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 7);

/**
 * ListWorkflowTemplatesRequest enumerates workflow templates with optional filters.
 *
 * @generated from message onboarding.v1.ListWorkflowTemplatesRequest
 */
export type ListWorkflowTemplatesRequest = Message<"onboarding.v1.ListWorkflowTemplatesRequest"> & {
	/**
	 * filter is a filter for workflow templates.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplatesFilter filter = 1;
	 */
	filter?: WorkflowTemplatesFilter;

	/**
	 * pagination controls the pagination of the response.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArguments;
};

/**
 * ListWorkflowTemplatesRequest enumerates workflow templates with optional filters.
 *
 * @generated from message onboarding.v1.ListWorkflowTemplatesRequest
 */
export type ListWorkflowTemplatesRequestJson = {
	/**
	 * filter is a filter for workflow templates.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplatesFilter filter = 1;
	 */
	filter?: WorkflowTemplatesFilterJson;

	/**
	 * pagination controls the pagination of the response.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message onboarding.v1.ListWorkflowTemplatesRequest.
 * Use `create(ListWorkflowTemplatesRequestSchema)` to create a new message.
 */
export const ListWorkflowTemplatesRequestSchema: GenMessage<ListWorkflowTemplatesRequest, { jsonType: ListWorkflowTemplatesRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 8);

/**
 * WorkflowTemplatesFilter is a filter for workflow templates.
 *
 * @generated from message onboarding.v1.WorkflowTemplatesFilter
 */
export type WorkflowTemplatesFilter = Message<"onboarding.v1.WorkflowTemplatesFilter"> & {
	/**
	 * key filters results to workflow templates with the provided key.
	 *
	 * @generated from field: optional string key = 1;
	 */
	key?: string;

	/**
	 * is_active filters results to workflow templates with the provided active status.
	 *
	 * @generated from field: optional bool is_active = 2;
	 */
	isActive?: boolean;
};

/**
 * WorkflowTemplatesFilter is a filter for workflow templates.
 *
 * @generated from message onboarding.v1.WorkflowTemplatesFilter
 */
export type WorkflowTemplatesFilterJson = {
	/**
	 * key filters results to workflow templates with the provided key.
	 *
	 * @generated from field: optional string key = 1;
	 */
	key?: string;

	/**
	 * is_active filters results to workflow templates with the provided active status.
	 *
	 * @generated from field: optional bool is_active = 2;
	 */
	isActive?: boolean;
};

/**
 * Describes the message onboarding.v1.WorkflowTemplatesFilter.
 * Use `create(WorkflowTemplatesFilterSchema)` to create a new message.
 */
export const WorkflowTemplatesFilterSchema: GenMessage<WorkflowTemplatesFilter, { jsonType: WorkflowTemplatesFilterJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 9);

/**
 * ListWorkflowTemplatesResponse returns the matching workflow templates.
 *
 * @generated from message onboarding.v1.ListWorkflowTemplatesResponse
 */
export type ListWorkflowTemplatesResponse = Message<"onboarding.v1.ListWorkflowTemplatesResponse"> & {
	/**
	 * templates are the workflow templates matching the requested filters.
	 *
	 * @generated from field: repeated onboarding.v1.WorkflowTemplate templates = 1;
	 */
	templates: WorkflowTemplate[];

	/**
	 * page_info contains pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * ListWorkflowTemplatesResponse returns the matching workflow templates.
 *
 * @generated from message onboarding.v1.ListWorkflowTemplatesResponse
 */
export type ListWorkflowTemplatesResponseJson = {
	/**
	 * templates are the workflow templates matching the requested filters.
	 *
	 * @generated from field: repeated onboarding.v1.WorkflowTemplate templates = 1;
	 */
	templates?: WorkflowTemplateJson[];

	/**
	 * page_info contains pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message onboarding.v1.ListWorkflowTemplatesResponse.
 * Use `create(ListWorkflowTemplatesResponseSchema)` to create a new message.
 */
export const ListWorkflowTemplatesResponseSchema: GenMessage<ListWorkflowTemplatesResponse, { jsonType: ListWorkflowTemplatesResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 10);

/**
 * DeleteWorkflowTemplateRequest removes a workflow template by id.
 *
 * @generated from message onboarding.v1.DeleteWorkflowTemplateRequest
 */
export type DeleteWorkflowTemplateRequest = Message<"onboarding.v1.DeleteWorkflowTemplateRequest"> & {
	/**
	 * workflow_template_id identifies the template to delete.
	 *
	 * @generated from field: string workflow_template_id = 1;
	 */
	workflowTemplateId: string;
};

/**
 * DeleteWorkflowTemplateRequest removes a workflow template by id.
 *
 * @generated from message onboarding.v1.DeleteWorkflowTemplateRequest
 */
export type DeleteWorkflowTemplateRequestJson = {
	/**
	 * workflow_template_id identifies the template to delete.
	 *
	 * @generated from field: string workflow_template_id = 1;
	 */
	workflowTemplateId?: string;
};

/**
 * Describes the message onboarding.v1.DeleteWorkflowTemplateRequest.
 * Use `create(DeleteWorkflowTemplateRequestSchema)` to create a new message.
 */
export const DeleteWorkflowTemplateRequestSchema: GenMessage<DeleteWorkflowTemplateRequest, { jsonType: DeleteWorkflowTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 11);

/**
 * DeleteWorkflowTemplateResponse acknowledges successful deletion.
 *
 * @generated from message onboarding.v1.DeleteWorkflowTemplateResponse
 */
export type DeleteWorkflowTemplateResponse = Message<"onboarding.v1.DeleteWorkflowTemplateResponse"> & {};

/**
 * DeleteWorkflowTemplateResponse acknowledges successful deletion.
 *
 * @generated from message onboarding.v1.DeleteWorkflowTemplateResponse
 */
export type DeleteWorkflowTemplateResponseJson = {};

/**
 * Describes the message onboarding.v1.DeleteWorkflowTemplateResponse.
 * Use `create(DeleteWorkflowTemplateResponseSchema)` to create a new message.
 */
export const DeleteWorkflowTemplateResponseSchema: GenMessage<DeleteWorkflowTemplateResponse, { jsonType: DeleteWorkflowTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 12);

/**
 * CreateStepTemplateRequest captures the information required to create a step template.
 *
 * @generated from message onboarding.v1.CreateStepTemplateRequest
 */
export type CreateStepTemplateRequest = Message<"onboarding.v1.CreateStepTemplateRequest"> & {
	/**
	 * workflow_template_id references the owning workflow template.
	 *
	 * @generated from field: string workflow_template_id = 1;
	 */
	workflowTemplateId: string;

	/**
	 * key defines the unique identifier for the step within the workflow template.
	 *
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * type defines the type of the step within the workflow template.
	 *
	 * @generated from field: onboarding.v1.StepType type = 3;
	 */
	type: StepType;

	/**
	 * display_name is the human-readable name for the step.
	 *
	 * @generated from field: string display_name = 4;
	 */
	displayName: string;

	/**
	 * description provides optional detail about the step template.
	 *
	 * @generated from field: string description = 5;
	 */
	description: string;

	/**
	 * data stores structured configuration for the step.
	 *
	 * @generated from field: onboarding.v1.StepData data = 6;
	 */
	data?: StepData;

	/**
	 * position determines where in the workflow template the step should be placed.
	 *
	 * @generated from field: onboarding.v1.StepTemplatePosition position = 7;
	 */
	position?: StepTemplatePosition;
};

/**
 * CreateStepTemplateRequest captures the information required to create a step template.
 *
 * @generated from message onboarding.v1.CreateStepTemplateRequest
 */
export type CreateStepTemplateRequestJson = {
	/**
	 * workflow_template_id references the owning workflow template.
	 *
	 * @generated from field: string workflow_template_id = 1;
	 */
	workflowTemplateId?: string;

	/**
	 * key defines the unique identifier for the step within the workflow template.
	 *
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * type defines the type of the step within the workflow template.
	 *
	 * @generated from field: onboarding.v1.StepType type = 3;
	 */
	type?: StepTypeJson;

	/**
	 * display_name is the human-readable name for the step.
	 *
	 * @generated from field: string display_name = 4;
	 */
	displayName?: string;

	/**
	 * description provides optional detail about the step template.
	 *
	 * @generated from field: string description = 5;
	 */
	description?: string;

	/**
	 * data stores structured configuration for the step.
	 *
	 * @generated from field: onboarding.v1.StepData data = 6;
	 */
	data?: StepDataJson;

	/**
	 * position determines where in the workflow template the step should be placed.
	 *
	 * @generated from field: onboarding.v1.StepTemplatePosition position = 7;
	 */
	position?: StepTemplatePositionJson;
};

/**
 * Describes the message onboarding.v1.CreateStepTemplateRequest.
 * Use `create(CreateStepTemplateRequestSchema)` to create a new message.
 */
export const CreateStepTemplateRequestSchema: GenMessage<CreateStepTemplateRequest, { jsonType: CreateStepTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 13);

/**
 * StepTemplatePosition defines the position of a step template within a workflow template.
 *
 * @generated from message onboarding.v1.StepTemplatePosition
 */
export type StepTemplatePosition = Message<"onboarding.v1.StepTemplatePosition"> & {
	/**
	 * @generated from field: string after_step_template_id = 1;
	 */
	afterStepTemplateId: string;

	/**
	 * @generated from field: string before_step_template_id = 2;
	 */
	beforeStepTemplateId: string;
};

/**
 * StepTemplatePosition defines the position of a step template within a workflow template.
 *
 * @generated from message onboarding.v1.StepTemplatePosition
 */
export type StepTemplatePositionJson = {
	/**
	 * @generated from field: string after_step_template_id = 1;
	 */
	afterStepTemplateId?: string;

	/**
	 * @generated from field: string before_step_template_id = 2;
	 */
	beforeStepTemplateId?: string;
};

/**
 * Describes the message onboarding.v1.StepTemplatePosition.
 * Use `create(StepTemplatePositionSchema)` to create a new message.
 */
export const StepTemplatePositionSchema: GenMessage<StepTemplatePosition, { jsonType: StepTemplatePositionJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 14);

/**
 * CreateStepTemplateResponse returns the newly created step template.
 *
 * @generated from message onboarding.v1.CreateStepTemplateResponse
 */
export type CreateStepTemplateResponse = Message<"onboarding.v1.CreateStepTemplateResponse"> & {
	/**
	 * step is the persisted step template.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step = 1;
	 */
	step?: StepTemplate;
};

/**
 * CreateStepTemplateResponse returns the newly created step template.
 *
 * @generated from message onboarding.v1.CreateStepTemplateResponse
 */
export type CreateStepTemplateResponseJson = {
	/**
	 * step is the persisted step template.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step = 1;
	 */
	step?: StepTemplateJson;
};

/**
 * Describes the message onboarding.v1.CreateStepTemplateResponse.
 * Use `create(CreateStepTemplateResponseSchema)` to create a new message.
 */
export const CreateStepTemplateResponseSchema: GenMessage<CreateStepTemplateResponse, { jsonType: CreateStepTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 15);

/**
 * UpdateStepTemplateRequest mutates an existing step template using the provided object.
 *
 * @generated from message onboarding.v1.UpdateStepTemplateRequest
 */
export type UpdateStepTemplateRequest = Message<"onboarding.v1.UpdateStepTemplateRequest"> & {
	/**
	 * step carries the desired state; the id field must be populated.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step = 1;
	 */
	step?: StepTemplate;

	/**
	 * update_mask limits which fields from step are applied.
	 *
	 * @generated from field: google.protobuf.FieldMask update_mask = 2;
	 */
	updateMask?: FieldMask;
};

/**
 * UpdateStepTemplateRequest mutates an existing step template using the provided object.
 *
 * @generated from message onboarding.v1.UpdateStepTemplateRequest
 */
export type UpdateStepTemplateRequestJson = {
	/**
	 * step carries the desired state; the id field must be populated.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step = 1;
	 */
	step?: StepTemplateJson;

	/**
	 * update_mask limits which fields from step are applied.
	 *
	 * @generated from field: google.protobuf.FieldMask update_mask = 2;
	 */
	updateMask?: FieldMaskJson;
};

/**
 * Describes the message onboarding.v1.UpdateStepTemplateRequest.
 * Use `create(UpdateStepTemplateRequestSchema)` to create a new message.
 */
export const UpdateStepTemplateRequestSchema: GenMessage<UpdateStepTemplateRequest, { jsonType: UpdateStepTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 16);

/**
 * UpdateStepTemplateResponse returns the updated step template.
 *
 * @generated from message onboarding.v1.UpdateStepTemplateResponse
 */
export type UpdateStepTemplateResponse = Message<"onboarding.v1.UpdateStepTemplateResponse"> & {
	/**
	 * step is the step template after applying the update.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step = 1;
	 */
	step?: StepTemplate;
};

/**
 * UpdateStepTemplateResponse returns the updated step template.
 *
 * @generated from message onboarding.v1.UpdateStepTemplateResponse
 */
export type UpdateStepTemplateResponseJson = {
	/**
	 * step is the step template after applying the update.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step = 1;
	 */
	step?: StepTemplateJson;
};

/**
 * Describes the message onboarding.v1.UpdateStepTemplateResponse.
 * Use `create(UpdateStepTemplateResponseSchema)` to create a new message.
 */
export const UpdateStepTemplateResponseSchema: GenMessage<UpdateStepTemplateResponse, { jsonType: UpdateStepTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 17);

/**
 * ListStepTemplatesRequest enumerates step templates using provided filters.
 *
 * @generated from message onboarding.v1.ListStepTemplatesRequest
 */
export type ListStepTemplatesRequest = Message<"onboarding.v1.ListStepTemplatesRequest"> & {
	/**
	 * filter is a filter for step templates.
	 *
	 * @generated from field: onboarding.v1.StepTemplatesFilter filter = 1;
	 */
	filter?: StepTemplatesFilter;

	/**
	 * pagination controls the pagination of the response.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArguments;
};

/**
 * ListStepTemplatesRequest enumerates step templates using provided filters.
 *
 * @generated from message onboarding.v1.ListStepTemplatesRequest
 */
export type ListStepTemplatesRequestJson = {
	/**
	 * filter is a filter for step templates.
	 *
	 * @generated from field: onboarding.v1.StepTemplatesFilter filter = 1;
	 */
	filter?: StepTemplatesFilterJson;

	/**
	 * pagination controls the pagination of the response.
	 *
	 * @generated from field: common.v1.PaginationArguments pagination = 2;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message onboarding.v1.ListStepTemplatesRequest.
 * Use `create(ListStepTemplatesRequestSchema)` to create a new message.
 */
export const ListStepTemplatesRequestSchema: GenMessage<ListStepTemplatesRequest, { jsonType: ListStepTemplatesRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 18);

/**
 * StepTemplatesFilter filters step templates returned by the list operation.
 *
 * @generated from message onboarding.v1.StepTemplatesFilter
 */
export type StepTemplatesFilter = Message<"onboarding.v1.StepTemplatesFilter"> & {
	/**
	 * workflow_template_id identifies the parent workflow template whose steps are listed.
	 *
	 * @generated from field: string workflow_template_id = 1;
	 */
	workflowTemplateId: string;

	/**
	 * key optionally restricts results to step templates with the provided key.
	 *
	 * @generated from field: optional string key = 2;
	 */
	key?: string;
};

/**
 * StepTemplatesFilter filters step templates returned by the list operation.
 *
 * @generated from message onboarding.v1.StepTemplatesFilter
 */
export type StepTemplatesFilterJson = {
	/**
	 * workflow_template_id identifies the parent workflow template whose steps are listed.
	 *
	 * @generated from field: string workflow_template_id = 1;
	 */
	workflowTemplateId?: string;

	/**
	 * key optionally restricts results to step templates with the provided key.
	 *
	 * @generated from field: optional string key = 2;
	 */
	key?: string;
};

/**
 * Describes the message onboarding.v1.StepTemplatesFilter.
 * Use `create(StepTemplatesFilterSchema)` to create a new message.
 */
export const StepTemplatesFilterSchema: GenMessage<StepTemplatesFilter, { jsonType: StepTemplatesFilterJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 19);

/**
 * ListStepTemplatesResponse returns step templates that match the requested filters.
 *
 * @generated from message onboarding.v1.ListStepTemplatesResponse
 */
export type ListStepTemplatesResponse = Message<"onboarding.v1.ListStepTemplatesResponse"> & {
	/**
	 * steps are the step templates matching the requested filters.
	 *
	 * @generated from field: repeated onboarding.v1.StepTemplate steps = 1;
	 */
	steps: StepTemplate[];

	/**
	 * page_info contains pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * ListStepTemplatesResponse returns step templates that match the requested filters.
 *
 * @generated from message onboarding.v1.ListStepTemplatesResponse
 */
export type ListStepTemplatesResponseJson = {
	/**
	 * steps are the step templates matching the requested filters.
	 *
	 * @generated from field: repeated onboarding.v1.StepTemplate steps = 1;
	 */
	steps?: StepTemplateJson[];

	/**
	 * page_info contains pagination information.
	 *
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message onboarding.v1.ListStepTemplatesResponse.
 * Use `create(ListStepTemplatesResponseSchema)` to create a new message.
 */
export const ListStepTemplatesResponseSchema: GenMessage<ListStepTemplatesResponse, { jsonType: ListStepTemplatesResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 20);

/**
 * DeleteStepTemplateRequest removes a step template by id.
 *
 * @generated from message onboarding.v1.DeleteStepTemplateRequest
 */
export type DeleteStepTemplateRequest = Message<"onboarding.v1.DeleteStepTemplateRequest"> & {
	/**
	 * step_template_id identifies the step template to delete.
	 *
	 * @generated from field: string step_template_id = 1;
	 */
	stepTemplateId: string;
};

/**
 * DeleteStepTemplateRequest removes a step template by id.
 *
 * @generated from message onboarding.v1.DeleteStepTemplateRequest
 */
export type DeleteStepTemplateRequestJson = {
	/**
	 * step_template_id identifies the step template to delete.
	 *
	 * @generated from field: string step_template_id = 1;
	 */
	stepTemplateId?: string;
};

/**
 * Describes the message onboarding.v1.DeleteStepTemplateRequest.
 * Use `create(DeleteStepTemplateRequestSchema)` to create a new message.
 */
export const DeleteStepTemplateRequestSchema: GenMessage<DeleteStepTemplateRequest, { jsonType: DeleteStepTemplateRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 21);

/**
 * DeleteStepTemplateResponse acknowledges successful deletion.
 *
 * @generated from message onboarding.v1.DeleteStepTemplateResponse
 */
export type DeleteStepTemplateResponse = Message<"onboarding.v1.DeleteStepTemplateResponse"> & {};

/**
 * DeleteStepTemplateResponse acknowledges successful deletion.
 *
 * @generated from message onboarding.v1.DeleteStepTemplateResponse
 */
export type DeleteStepTemplateResponseJson = {};

/**
 * Describes the message onboarding.v1.DeleteStepTemplateResponse.
 * Use `create(DeleteStepTemplateResponseSchema)` to create a new message.
 */
export const DeleteStepTemplateResponseSchema: GenMessage<DeleteStepTemplateResponse, { jsonType: DeleteStepTemplateResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 22);

/**
 * WorkflowTemplate represents a workflow template and its step templates.
 *
 * @generated from message onboarding.v1.WorkflowTemplate
 */
export type WorkflowTemplate = Message<"onboarding.v1.WorkflowTemplate"> & {
	/**
	 * id is the workflow template identifier.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * key is the unique name for the template.
	 *
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * type of the workflow template.
	 *
	 * @generated from field: onboarding.v1.WorkflowType type = 3;
	 */
	type: WorkflowType;

	/**
	 * display_name is the human-readable name for the template.
	 *
	 * @generated from field: string display_name = 4;
	 */
	displayName: string;

	/**
	 * description provides optional detail about the workflow template.
	 *
	 * @generated from field: string description = 5;
	 */
	description: string;

	/**
	 * is_active indicates whether new runs can be created from this template.
	 *
	 * @generated from field: bool is_active = 6;
	 */
	isActive: boolean;

	/**
	 * created_at records when the template was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: Timestamp;

	/**
	 * updated_at records when the template was last modified.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: Timestamp;

	/**
	 * steps lists the step templates associated with this workflow template.
	 *
	 * @generated from field: repeated onboarding.v1.StepTemplate steps = 9;
	 */
	steps: StepTemplate[];
};

/**
 * WorkflowTemplate represents a workflow template and its step templates.
 *
 * @generated from message onboarding.v1.WorkflowTemplate
 */
export type WorkflowTemplateJson = {
	/**
	 * id is the workflow template identifier.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * key is the unique name for the template.
	 *
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * type of the workflow template.
	 *
	 * @generated from field: onboarding.v1.WorkflowType type = 3;
	 */
	type?: WorkflowTypeJson;

	/**
	 * display_name is the human-readable name for the template.
	 *
	 * @generated from field: string display_name = 4;
	 */
	displayName?: string;

	/**
	 * description provides optional detail about the workflow template.
	 *
	 * @generated from field: string description = 5;
	 */
	description?: string;

	/**
	 * is_active indicates whether new runs can be created from this template.
	 *
	 * @generated from field: bool is_active = 6;
	 */
	isActive?: boolean;

	/**
	 * created_at records when the template was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 7;
	 */
	createdAt?: TimestampJson;

	/**
	 * updated_at records when the template was last modified.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 8;
	 */
	updatedAt?: TimestampJson;

	/**
	 * steps lists the step templates associated with this workflow template.
	 *
	 * @generated from field: repeated onboarding.v1.StepTemplate steps = 9;
	 */
	steps?: StepTemplateJson[];
};

/**
 * Describes the message onboarding.v1.WorkflowTemplate.
 * Use `create(WorkflowTemplateSchema)` to create a new message.
 */
export const WorkflowTemplateSchema: GenMessage<WorkflowTemplate, { jsonType: WorkflowTemplateJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 23);

/**
 * StepTemplate represents a reusable onboarding workflow step definition.
 *
 * @generated from message onboarding.v1.StepTemplate
 */
export type StepTemplate = Message<"onboarding.v1.StepTemplate"> & {
	/**
	 * id is the step template identifier.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * workflow_template_id references the owning workflow template.
	 *
	 * @generated from field: string workflow_template_id = 2;
	 */
	workflowTemplateId: string;

	/**
	 * type uniquely identifies the step within the workflow template.
	 *
	 * @generated from field: onboarding.v1.StepType type = 3;
	 */
	type: StepType;

	/**
	 * key uniquely identifies the step within the workflow template.
	 *
	 * @generated from field: string key = 4;
	 */
	key: string;

	/**
	 * display_name is the human-readable name for the step.
	 *
	 * @generated from field: string display_name = 5;
	 */
	displayName: string;

	/**
	 * description provides optional detail about the step template.
	 *
	 * @generated from field: string description = 6;
	 */
	description: string;

	/**
	 * ordinal_position is the LexoRank-style token that orders steps within a workflow template; smaller tokens sort first.
	 *
	 * @generated from field: string ordinal_position = 7;
	 */
	ordinalPosition: string;

	/**
	 * metadata stores structured configuration for the step.
	 * google.protobuf.Struct metadata = 12;
	 *
	 * @generated from field: onboarding.v1.StepData data = 8;
	 */
	data?: StepData;

	/**
	 * created_at records when the step template was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: Timestamp;

	/**
	 * updated_at records when the step template was last modified.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: Timestamp;
};

/**
 * StepTemplate represents a reusable onboarding workflow step definition.
 *
 * @generated from message onboarding.v1.StepTemplate
 */
export type StepTemplateJson = {
	/**
	 * id is the step template identifier.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * workflow_template_id references the owning workflow template.
	 *
	 * @generated from field: string workflow_template_id = 2;
	 */
	workflowTemplateId?: string;

	/**
	 * type uniquely identifies the step within the workflow template.
	 *
	 * @generated from field: onboarding.v1.StepType type = 3;
	 */
	type?: StepTypeJson;

	/**
	 * key uniquely identifies the step within the workflow template.
	 *
	 * @generated from field: string key = 4;
	 */
	key?: string;

	/**
	 * display_name is the human-readable name for the step.
	 *
	 * @generated from field: string display_name = 5;
	 */
	displayName?: string;

	/**
	 * description provides optional detail about the step template.
	 *
	 * @generated from field: string description = 6;
	 */
	description?: string;

	/**
	 * ordinal_position is the LexoRank-style token that orders steps within a workflow template; smaller tokens sort first.
	 *
	 * @generated from field: string ordinal_position = 7;
	 */
	ordinalPosition?: string;

	/**
	 * metadata stores structured configuration for the step.
	 * google.protobuf.Struct metadata = 12;
	 *
	 * @generated from field: onboarding.v1.StepData data = 8;
	 */
	data?: StepDataJson;

	/**
	 * created_at records when the step template was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 13;
	 */
	createdAt?: TimestampJson;

	/**
	 * updated_at records when the step template was last modified.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 14;
	 */
	updatedAt?: TimestampJson;
};

/**
 * Describes the message onboarding.v1.StepTemplate.
 * Use `create(StepTemplateSchema)` to create a new message.
 */
export const StepTemplateSchema: GenMessage<StepTemplate, { jsonType: StepTemplateJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_builder, 24);

/**
 * WorkflowBuilderService exposes management operations for workflow and step templates.
 *
 * @generated from service onboarding.v1.WorkflowBuilderService
 */
export const WorkflowBuilderService: GenService<{
	/**
	 * CreateWorkflowTemplate provisions a new workflow template with optional steps.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.CreateWorkflowTemplate
	 */
	createWorkflowTemplate: {
		methodKind: "unary";
		input: typeof CreateWorkflowTemplateRequestSchema;
		output: typeof CreateWorkflowTemplateResponseSchema;
	};
	/**
	 * UpdateWorkflowTemplate mutates editable fields on an existing workflow template.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.UpdateWorkflowTemplate
	 */
	updateWorkflowTemplate: {
		methodKind: "unary";
		input: typeof UpdateWorkflowTemplateRequestSchema;
		output: typeof UpdateWorkflowTemplateResponseSchema;
	};
	/**
	 * GetWorkflowTemplate fetches a workflow template using an id- or key-based selector.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.GetWorkflowTemplate
	 */
	getWorkflowTemplate: {
		methodKind: "unary";
		input: typeof GetWorkflowTemplateRequestSchema;
		output: typeof GetWorkflowTemplateResponseSchema;
	};
	/**
	 * ListWorkflowTemplates enumerates workflow templates, optionally including their steps.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.ListWorkflowTemplates
	 */
	listWorkflowTemplates: {
		methodKind: "unary";
		input: typeof ListWorkflowTemplatesRequestSchema;
		output: typeof ListWorkflowTemplatesResponseSchema;
	};
	/**
	 * DeleteWorkflowTemplate removes a workflow template by id.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.DeleteWorkflowTemplate
	 */
	deleteWorkflowTemplate: {
		methodKind: "unary";
		input: typeof DeleteWorkflowTemplateRequestSchema;
		output: typeof DeleteWorkflowTemplateResponseSchema;
	};
	/**
	 * CreateStepTemplate adds a new step template to a workflow template.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.CreateStepTemplate
	 */
	createStepTemplate: {
		methodKind: "unary";
		input: typeof CreateStepTemplateRequestSchema;
		output: typeof CreateStepTemplateResponseSchema;
	};
	/**
	 * UpdateStepTemplate mutates editable fields on an existing step template.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.UpdateStepTemplate
	 */
	updateStepTemplate: {
		methodKind: "unary";
		input: typeof UpdateStepTemplateRequestSchema;
		output: typeof UpdateStepTemplateResponseSchema;
	};
	/**
	 * ListStepTemplates enumerates step templates for a workflow template.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.ListStepTemplates
	 */
	listStepTemplates: {
		methodKind: "unary";
		input: typeof ListStepTemplatesRequestSchema;
		output: typeof ListStepTemplatesResponseSchema;
	};
	/**
	 * MoveStepTemplate moves a step template within a workflow template.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.MoveStepTemplate
	 */
	moveStepTemplate: {
		methodKind: "unary";
		input: typeof MoveStepTemplateRequestSchema;
		output: typeof MoveStepTemplateResponseSchema;
	};
	/**
	 * DeleteStepTemplate removes a step template from a workflow template.
	 *
	 * @generated from rpc onboarding.v1.WorkflowBuilderService.DeleteStepTemplate
	 */
	deleteStepTemplate: {
		methodKind: "unary";
		input: typeof DeleteStepTemplateRequestSchema;
		output: typeof DeleteStepTemplateResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_onboarding_v1_builder, 0);
